import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function CTAFinalSection() {
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 bg-brand-black text-white relative overflow-hidden" data-id="element-34">
      {/* Background decoration */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] rounded-full bg-brand-orange/5 blur-3xl pointer-events-none" data-id="element-35"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} data-id="element-37">
          <h2 className="text-4xl md:text-6xl font-heading font-extrabold mb-6 leading-tight" data-id="element-38">
            Entrá hoy con <span className="text-brand-orange" data-id="element-39">pago único</span>{' '}
            y evitá la inversión mensual
          </h2>

          <p className="text-xl md:text-2xl text-gray-400 mb-12 max-w-2xl mx-auto" data-id="element-40">
            Dejá de perder tiempo improvisando. Ordená tu servicio y empezá a
            escalar de forma predecible.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-41">
            <a href="https://centrocumbre.com/cart/46319925100743:1" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-xl px-12 py-5 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:scale-[1.05] transition-transform text-center animate-pulse-subtle" data-id="element-42">
              Ingresar ahora
            </a>

            <a href="https://centrocumbre.com/cart/46319925100743:1" className="w-full sm:w-auto border-2 border-white/20 text-white font-bold text-lg px-10 py-4 rounded-xl hover:bg-white/10 transition-colors text-center" data-id="element-43">
              Escalar mi negocio ahora
            </a>

            <a href="https://wa.me/5492617508744?text=Hola,%20quiero%20más%20información%20sobre%20el%20método%20VSPP" className="flex items-center gap-2 text-gray-400 font-medium hover:text-white transition-colors mt-4" data-id="element-44">
              <MessageCircle size={20} className="text-[#25D366]" data-id="element-45" />
              Consultar por WhatsApp
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}